export default {
  CHAT_WINDOW_CHANGE: 'CHAT_WINDOW_CHANGE',
};